// extracted by mini-css-extract-plugin
export default {"Project":"Project_Project__Lf-UX"};